import { render } from "./merchantPay.vue?vue&type=template&id=47a82434&scoped=true"
import script from "./merchantPay.vue?vue&type=script&lang=js"
export * from "./merchantPay.vue?vue&type=script&lang=js"

import "./merchantPay.vue?vue&type=style&index=0&id=47a82434&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/xiaocanghui/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a82434"]])

export default __exports__